<template>
  <!-- NOTE (TEMPLATE) to show all proposals -->

  <div class="animated fadeIn">
    <b-tabs pills vertical card>
      <b-tab title="تغییرات آخرین نسخه">
        <div class="p-3">
          <h5>نسخه 3.7.22</h5>
          <ul>
            <li class="text-primary">تاریخ انتشار: 20 خرداد 1402</li>
            <li>اضافه شدن جنسیت برای نماینده مشتری در فرم استعلام ارسال به کارخانه</li>
            <li>برطرف کردن مشکل سرچ در مدیریت منابع انسانی </li>
          </ul>
        </div>
        <div class="p-3">
          <h5>نسخه 3.0.0-j</h5>
          <ul>
            <li class="text-primary">تاریخ انتشار: 19 خرداد 1400</li>

            <li>افزودن اولیه ماژول انبارداری</li>
          </ul>
        </div>
      </b-tab>
      <b-tab title="برنامه‌ریزی بروزرسانی‌های آتی">
        <div class="p-3">
          <ul>
            <li class="version-major-future">نسخه 3.0.0-l</li>
            <ul>
              <li class="text-primary">تاریخ انتشار: 23 تیر 1400</li>
              <li>نهایی سازی دفترمرکزی و کارخانه و مهاجرت به سامانه جدید</li>
            </ul>
            <li class="version-major-future">نسخه 3.0.0-p</li>
            <ul>
              <li class="text-primary">تاریخ انتشار: 6 مرداد 1400</li>
              <li>نهایی سازی انبارداری و نسخه اولیه حسابداری</li>
            </ul>
            <li class="version-major-future">نسخه 3.0.0-w</li>
            <ul>
              <li class="text-primary">تاریخ انتشار: 14 مرداد 1400</li>
              <li>نهایی سازی حسابداری و نسخه اولیه منابع انسانی</li>
            </ul>
            <li class="version-major-future">نسخه 3.0.0-x</li>
            <ul>
              <li class="text-primary">تاریخ انتشار: 21 مرداد 1400</li>
              <li>نهایی سازی منابع انسانی و نسخه اولیه داشبوردهای مدیریتی</li>
            </ul>
            <li class="version-major-future">نسخه 3.0.0-y</li>
            <ul>
              <li class="text-primary">تاریخ انتشار: 26 مرداد 1400</li>
              <li>نهایی سازی گزارش‌های مدیریتی</li>
            </ul>
            <li class="version-major-future">نسخه 3.0.0-z</li>
            <ul>
              <li class="text-primary">تاریخ انتشار: 10 شهریور 1400</li>
              <li>تست نهایی و بهینه‌سازی عملکردی</li>
            </ul>
            <li class="version-major-future">نسخه 3.0.1</li>
            <ul>
              <li class="text-primary">تاریخ انتشار: 17 شهریور 1400</li>
              <li>انتشار کامل</li>
            </ul>
          </ul>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {};
  },

  methods: {},
  updated() {},
  mounted() {},
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
.bg-primary {
  background-color: #693d70 !important;
}


.version-major {
  font-weight: bold;
  font-size: 135%;
  margin-top: 25px;
}

.version-minor {
  font-weight: bold;
  font-size: 120%;
  margin-top: 15px;
  margin-right: 15px;
}

.version-patch {
  font-style: italic;
  margin-top: 5px;
  margin-right: 25px;
}

.version-major-future {
  font-weight: bold;
  font-size: 135%;
  color: gray;
  margin-top: 25px;
}

.version-minor-future {
  font-weight: bold;
  font-size: 120%;
  color: gray;
  margin-top: 15px;
  margin-right: 15px;
}

.version-patch-future {
  font-style: italic;
  color: gray;
  margin-top: 5px;
  margin-right: 25px;
}
</style>
